import { Component, ElementRef,AfterViewInit, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ScrollIntentGate } from 'src/app/shared/scroll-intent-gate';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AppSettings } from 'src/app/services/AppSettings';
import { CandidateService } from 'src/app/services/CandidateService';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { ApiService } from 'src/app/services/api.service';
import { candidateModel } from 'src/app/services/candidateModel';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { JobService } from 'src/app/services/job.service';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import { JobCardComponent } from '../../cards/job-card/job-card.component';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import Swal from 'sweetalert2';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { APP_ICONS } from 'src/app/icons/icon-provider';



@Component({
  selector: 'app-job-applied-candidates',
  standalone: true,
  imports: [CommonModule, FormsModule,
JobCardComponent, CommonSkeletonComponent, InfiniteScrollModule,
    NgIconComponent,
  ],
  providers: [provideIcons(APP_ICONS)],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './jobs-applied.component.html',
  styleUrls: ['./jobs-applied.component.scss'],
  inputs: ['candidateDetails', 'designVersion']
})
export class JobsAppliedcandidateComponent extends FormValidation implements OnInit, OnChanges,AfterViewInit  {
  passValues: any = []
  // Marketplace Jobs ("Available jobs" stat) — total count from the
  // findTopSuggestedJobs response (data.totalCount).
  marketplaceTotalCount: number = 0;
  // Top Match card — highest match score (data.maxScore), overall across all
  // ranked jobs, so it's set directly from each response. Via Recruiters card —
  // count of listed jobs posted by a FREELANCE_RECRUITER
  // (data.freelanceRecruiterCount); that count is per-page, so it accumulates
  // across pagination and is reset on a fresh load.
  topMatchScore: number = 0;
  viaRecruitersCount: number = 0;
  flag: boolean = false;
  userType: any;
  designVersion!: string;
  colorLists: any;
  fiter_Route_candi_status = null;
  private suggestedJobsRequestId = 0;
  candidateId: any;
  obj: any = {
    limit: 10,
    searchAfterKey: null,
    currentStatus: null,
    searchText:''
  }
  stopscrollFlag: boolean = false;
  jobAppliedStatusList: Array<any>=[];
  messageShown: boolean = false
  entitySent: any = { entity: 'jobs applied' };
  jobsAppliedFoundStatus: any = 'Fetching applied jobs...'
  previousSearchAfterKey: any = null
  responseReceived: boolean = false;

  // Get appropriate message based on screen type
  get noResultMessage(): string {
    if (this.pageFrom === 'suggestedJobs') {
      if (!this.responseReceived) {
        return 'Our AI is analyzing your profile and matching you with the best opportunities...';
      } else {
        return 'No marketplace jobs available yet. Our AI is processing your profile to find the perfect matches. Please check back soon!';
      }
    } else {
      if (!this.responseReceived) {
        return 'Fetching applied jobs...';
      } else {
        return this.jobsAppliedFoundStatus;
      }
    }
  }

  get noResultSvgType(): string {
    if (this.pageFrom === 'suggestedJobs') {
      if (!this.responseReceived) {
        return 'customAiProcessing';
      } else {
        return 'customAiProcessing';
      }
    } else {
      if (this.responseReceived) {
        return 'customNotFound';
      } else {
        return 'tablerUserSearch';
      }
    }
  }
  readonly GigsumoConstants = GigsumoConstants;
  userId = localStorage.getItem('userId');

  // Stage selection and search properties
  selectedStage: string = 'ALL';
  stageCounts: any = {
    all: 0,
    applied: 0,
    inProcess: 0,
    selected: 0,
    offered: 0,
    onboarded: 0
  };
  searchText: string = '';
  private searchSubject = new Subject<string>();
  allJobsData: any[] = []; // Store all jobs for filtering
  @Input() jobsFoundStatus: any;
  sliderSubscriber: Subscription;
  isFilterOpen: boolean = false;
  panel!: string;
  candidateDetails!: candidateModel;
  @Input() clickedJobIdIntraction!: string;
  jobId!: string;
  filterApplicantData: any;
  tempStatusList: any;
  subscription: Subscription;
  loadAPIcall:boolean=false;
  // Sentinel pagination: a page is requested only when the bottom sentinel
  // ENTERS view (the user scrolled it in). If it enters while a page is
  // already loading, the trigger is remembered and the observer is re-armed
  // once that page has landed (afterPageSettled), so the list never sticks
  // waiting for a scroll-up-then-down — and it never chains pages on its own
  // (no scroll listener: momentum scroll events must not count as new scrolls).
  private pendingSentinelTrigger = false;
  private afterPageSettled(): void {
    // A page just landed: the next one needs a fresh physical input first
    // (see scrollGate). Disarming here, rather than when the fetch starts,
    // means wheel notches delivered WHILE the page was loading don't count.
    this.scrollGate.pageLanded();
    if (!this.pendingSentinelTrigger) return;
    this.pendingSentinelTrigger = false;
    setTimeout(() => this.setupScrollObserver());
  }

  // User-intent gate (src/app/shared/scroll-intent-gate.ts): after a page
  // lands, the next page needs a NEW physical input — a fast wheel flick's
  // smooth-scroll tail must not chain pages on its own. This component's
  // "at bottom" signal is the sentinel observer below; the directive-only
  // tabs use ScrollIntentGate.nearBottom() on the container instead.
  private sentinelInView = false;
  readonly scrollGate = new ScrollIntentGate({
    onArmAtBottom: () => this.onScrollDown(),
    isAtBottom: () => this.sentinelInView,
  });
  response: any[];

  @Input() pageFrom:any;

  /** Draft candidates never get AI matches (the fetch is blocked above), so the
   *  Marketplace Jobs empty state says why instead of "will appear here". */
  get isDraftCandidate(): boolean {
    const status = this.candidateDetails?.status?.toUpperCase();
    return status === 'DRAFT' || status === 'DRAFTED';
  }
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
   @ViewChild('scrollSentinel') scrollSentinel: ElementRef;
  private intersectionObserver: IntersectionObserver | null = null;

  constructor(private util: UtilService, private searchData: SearchData, private activatedRoute: ActivatedRoute,
    private router: Router, private api: ApiService, private candidateService: CandidateService, private jobService: JobService,
    private gigsumoService: GigsumoService) {
    super();
    this.sliderSubscriber = this.jobService.getSliderToggle().subscribe(value => {
      this.panel = value.panel;

      if (value.panel == 'jobs applied') {
        if (!value.value) {
          if (value.filterData != null) {
            this.previousSearchAfterKey=null;
            this.obj.searchAfterKey = null;
            this.onFilterToggle(value.filterData);
          }
        }
        if (value.value == true && !this.isFilterOpen) {
          this.openFilterSlider();
        } else {
          this.isFilterOpen = false;
          this.closeFilterSlider();
        }
      }
    })
    this.colorLists = this.gigsumoService.colorClass
    //this.jobAppliedStatusList = [...GigsumoConstants.JOB_LIST_STATUS];
  }
  fullName: any;

  ngOnInit(): void {
    this.passValues=[];
    this.searchText = '';
    // this.loadAPIcall=true
      this.candidateId = this.candidateDetails.candidateId;
      this.fullName = this.candidateDetails.firstName + " " + this.candidateDetails.lastName

    this.selectedStage = 'ALL';

    // Initialize suggestedJobs tab to show "No Marketplace Jobs Found" immediately
    if (this.pageFrom === 'suggestedJobs'&&!this.loadAPIcall) {
      this.responseReceived = true;
      this.passValues = [];
      this.stopscrollFlag = true;
      this.marketplaceTotalCount = 0;
    }

    // Setup debounced search - 400ms delay
    this.searchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(() => {
      this.executeSearch();
    });

    this.scrollSubject.pipe(
      debounceTime(100)
    ).subscribe(() => {
      this.loadNextPage();
    });

    this.userType = localStorage.getItem('userType');
    this.checkCeipalFreePlan();
    this.subscription = this.jobService.confirmationResult$.subscribe(() => {
      if(this.pageFrom == 'suggestedJobs'){
        // Prevent API call for Draft status candidates
        const candidateStatus = this.candidateDetails?.status?.toUpperCase();
        console.log('[jobs-applied confirmationResult$] candidateStatus:', candidateStatus, 'candidateDetails.status:', this.candidateDetails?.status);
        
        if (candidateStatus === 'DRAFT' || candidateStatus === 'DRAFTED') {
          console.log('[jobs-applied confirmationResult$] Blocking API call for Draft candidate');
          this.loadAPIcall = false;
          this.afterPageSettled();
          this.responseReceived = true;
          this.stopscrollFlag = true;
        } else {
          console.log('[jobs-applied confirmationResult$] Proceeding with API call');
          this.getSuggestedJobsList();
        }
      }else {
        this.loadAPIcall = true;
        this.getAppliedFilter();
        this.getJobsAppliedCounts();
      }

    });
  }
    ngAfterViewInit(): void {
    this.setupScrollObserver();
    this.scrollGate.attach();
  }

  private setupScrollObserver(): void {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
    if (!this.scrollSentinel?.nativeElement) return;

    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        this.sentinelInView = entries[0].isIntersecting;
        if (!entries[0].isIntersecting) return;
        if (this.loadAPIcall) { this.pendingSentinelTrigger = true; return; }
        this.onScrollDown();
      },
      { root: null, rootMargin: '200px', threshold: 0 }
    );
    this.intersectionObserver.observe(this.scrollSentinel.nativeElement);
  }

  previousValue_jobDetails:any={};
  // ngOnChanges(changes: SimpleChanges): void {
  //    this.passValues=[];
  //    this.searchText = '';
     
  //   if (changes.candidateDetails.currentValue) {
  //     this.candidateDetails = changes.candidateDetails.currentValue;
  //     if( changes.clickedJobIdIntraction &&changes.clickedJobIdIntraction.currentValue!=undefined){
  //       this.jobId = changes.clickedJobIdIntraction.currentValue;
  //     }else{
  //       this.jobId =undefined;
  //     }

  //     this.selectedStage = 'ALL';
      
  //     this.previousValue_jobDetails = changes.candidateDetails.previousValue;
  //       this.obj.searchAfterKey=null;
  //       this.previousSearchAfterKey=null;
  //       this.payload.searchAfterKey = null;
  //       this.passValues = [];
  //       this.stopscrollFlag = false;

  //       // Reset scroll position to top when candidate changes
  //       this.resetScrollPosition();

  //       if(this.pageFrom == 'suggestedJobs'){
  //         this.getSuggestedJobsList();
  //       }else {
  //         this.loadAPIcall=true;
  //         this.getAppliedFilter();
  //         this.getJobsAppliedCounts();
  //       }

  //   }
  // }

  ngOnChanges(changes: SimpleChanges): void {
  this.passValues = [];
  this.searchText = '';

  // Guard: `changes.candidateDetails` is only present when that specific
  // Input actually changed. Double-clicking the menu can fire ngOnChanges
  // with only `pageFrom` / `clickedJobIdIntraction` changed, leaving
  // `changes.candidateDetails` undefined — accessing `.currentValue` on it
  // threw, aborting this hook and leaving pagination state (searchAfterKey /
  // loadAPIcall) stuck from the previous run.
  if (changes.candidateDetails && changes.candidateDetails.currentValue) {
    this.candidateDetails = changes.candidateDetails.currentValue;

    if (changes.clickedJobIdIntraction && changes.clickedJobIdIntraction.currentValue != undefined) {
      this.jobId = changes.clickedJobIdIntraction.currentValue;
    } else {
      this.jobId = undefined;
    }

    this.selectedStage = 'ALL';

    this.previousValue_jobDetails = changes.candidateDetails.previousValue;
    this.obj.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.payload.searchAfterKey = null;
    this.passValues = [];
    this.stopscrollFlag = false;
    // Invalidate any in-flight page fetch NOW — the response guards compare
    // against these counters, and waiting for the next fetch to bump them
    // leaves a window (e.g. during the async getAppliedFilter) where a stale
    // pagination response would append into the just-cleared list.
    this.appliedJobsRequestId++;
    this.suggestedJobsRequestId++;
    this.loadAPIcall = false;
    this.afterPageSettled();

    this.resetScrollPosition();

//     if (this.pageFrom == 'suggestedJobs') {
//       this.getSuggestedJobsList();
//     } else {
//       this.loadAPIcall = true;
//       this.getAppliedFilter();
//       this.getJobsAppliedCounts();
//     }
//   }
// }
if (this.pageFrom == 'suggestedJobs') {
      this.getSuggestedJobsList();
    } else {
      this.loadAPIcall = true;
      this.getAppliedFilter();
      this.getJobsAppliedCounts();
    }
  }

    setTimeout(() => this.setupScrollObserver());
  }



  // ngOnDestroy(): void {
  //   if (this.sliderSubscriber) {
  //     this.sliderSubscriber.unsubscribe();
  //   }
  //   if (this.subscription) {
  //     this.subscription.unsubscribe();
  //   }
  //   if (this.searchSubject) {
  //     this.searchSubject.complete();
  //   }
  // }
  ngOnDestroy(): void {
    if (this.sliderSubscriber) {
      this.sliderSubscriber.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.searchSubject) {
      this.searchSubject.complete();
    }
    if (this.scrollSubject) {
      this.scrollSubject.complete();
    }
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
    this.scrollGate.detach();
  }

  private checkCeipalFreePlan(): void {
    if (this.pageFrom === 'suggestedJobs') {
      const membershipType = localStorage.getItem('MemberShipType');
      if ((this.candidateDetails as any)?.source === 'CEIPAL' && membershipType === 'Free') {
        Swal.fire({
          icon: 'info',
          title: '',
          text: 'AI features are not available for CEIPAL Free plan. Please upgrade your plan to access AI-powered recommendations.',
          showConfirmButton: true,
          confirmButtonText: 'OK'
        });
      }
    }
  }

  // Reset scroll container to top position with smooth behavior.
  // The `@ViewChild('scrollContainer')` ref only binds to the V2 template
  // block (scrollContainer is inside `designVersion !== 'v3'`). For V3,
  // the shared scroll container is `.jc-v3-entity-details-body` owned by
  // the new-candidate host — fall back to that so search / filter / stage
  // click correctly scroll to top in both versions. Mirror of the same
  // fix applied to `job-applicants.component.ts` (/newjobs G5).
  resetScrollPosition(): void {
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      this.scrollContainer.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const v3Container = document.querySelector('.jc-v3-entity-details-body') as HTMLElement | null;
    if (v3Container) {
      v3Container.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  getAppliedFilter() {
    let entireApplyStatusList: any = []
    const default_apply_stages = GigsumoConstants.JOB_APPLIED_DEFAULT_STAGES;
    // this.loadAPIcall = true;
    this.api.create('listvalue/findbyList' , {domain : "JOB_APPLICATION_SUPPLIER_ACTIONS,JOB_APPLICATION_BLOCKING_ACTIONS"}).subscribe(res=>{
      const sorted : Array<any> =  res.data.JOB_APPLICATION_SUPPLIER_ACTIONS && res.data.JOB_APPLICATION_SUPPLIER_ACTIONS.listItems;
      this.filterApplicantData = res.data;
      this.loadAPIcall = false;
      this.afterPageSettled();
      if(sorted){
        // Store all available statuses
        entireApplyStatusList = sorted
        .map(x => {
          return {itemId : x.itemId , value : x.value};
        });
        this.tempStatusList = entireApplyStatusList;

        // Check if 'ALL' is selected (default on load)
        if (this.selectedStage === 'ALL' || !this.selectedStage) {
          // Load ALL statuses, not just defaults
          this.jobAppliedStatusList = [...entireApplyStatusList];
          console.log('Loading ALL job applied statuses on initialization:', this.jobAppliedStatusList.length);
        } else {
          // Load only default stages
          this.jobAppliedStatusList = sorted
          .filter(x=>default_apply_stages.includes(x.itemId))
          .map(x => {
            return {itemId : x.itemId , value : x.value};
          });
          console.log('Loading DEFAULT job applied statuses:', this.jobAppliedStatusList.length);
        }

        // Update removedData to reflect current selection
        this.removedData = this.updatedArr();

        // Build the status string for API call
        const statusString = this.jobAppliedStatusList.map(x => x.itemId).toString();

        console.log('Initial filter status string:', statusString);

        // Load jobs with the selected statuses
        if (statusString) {
          this.filterByStatus(statusString);
        } else {
          console.warn('No statuses available to filter');
          this.jobsAppliedFoundStatus = "No filter statuses available.";
        }
      }
     });
  }

  onNgModelChange(event, value) {

  }

  openFilterSlider() {

    if (!this.isFilterOpen) {
      this.isFilterOpen = true;
      this.candidateService.setDataForFilter({...this.removedData});
      this.jobService.setSliderToggle(true, 'jobs applied', null,false);
    }
  }

  closeFilterSlider() {
    if (this.isFilterOpen) {
      this.isFilterOpen = false;
      this.jobService.setSliderToggle(false, 'jobs applied', null,false);
    }
  }

  onFilterToggle(value: any):void {

    const receivedData = JSON.parse(value);
    const status = receivedData ? receivedData.jobsAppliedStatus : null;
     if(status){
      const d =  this.tempStatusList.filter((e: any) => status.some((v: any) => v === e.itemId));
      this.jobAppliedStatusList = d;
      this.removedData = {};
      this.jobAppliedStatusList.forEach(element => {
          this.removedData[element.itemId] =  true;
      });
    }
    this.stopscrollFlag = false
    this.passValues = []
     this.obj.searchAfterKey = null;
    // Reset scroll position to top when filter is applied
    this.resetScrollPosition();
    this.filterByStatus(this.jobAppliedStatusList.map(c=>c.itemId).toString());
  }

  apply(values: any) {
    this.util.startLoader();
    let datas: any = {};
    let routedata: any;
    var temparr = [];
    var datacheck = [{ 'userId': localStorage.getItem('userId') }]
    datas.jobPostedBy = localStorage.getItem('userId');
    datas.jobId = values.jobId;
    datas.appliedBy = datacheck;
    values.userType = values.user.userType;
    values.jobfilter = true;
    values.filterTitle = 'Select';
    this.router.navigate(["candidates"], { queryParams: values });
  }

  like(values: any, index) {


    let datas: any = {};
    datas.jobPostedBy = localStorage.getItem('userId');
    datas.jobId = values.jobId;
    this.util.startLoader();
    this.api.updatePut("jobs/updateJobLiked", datas).subscribe((res) => {

      this.passValues[index].isLiked = true;
      this.passValues[index].likesCount = this.passValues[index].likesCount + 1

      this.util.stopLoader();
    }, err => {
      this.util.stopLoader();
    });
  }


  open(values: any) {
    let data: any = {};
    data.jobPostedBy = localStorage.getItem('userId');
    data.jobId = values.jobId;
    this.util.startLoader();
    if (values.jobPostedBy != this.userId || !values.isViewed) {
      this.api.updatePut("jobs/updateJobViewed", data).subscribe((res) => {
        this.router.navigate(['newcandidates/jobs-applied'], { queryParams: data })
        this.util.stopLoader();
      }, err => {
        this.util.stopLoader();
      });
    } else {
      this.router.navigate(['newcandidates/jobs-applied'], { queryParams: data })
    }
  }

  filterByStatus(status: any) {

    if (status) {
      this.getAppliedJobsList(status);
    } else {
      this.jobsAppliedFoundStatus = 'Please select appropriate filters to show relevant job applieds.';
      this.loadAPIcall=false;
      this.afterPageSettled();

      this.returnmsgtoActivity();
    }

  }


//   async getAppliedJobsList(status) {
//     this.prepareRequest(status);
//     const reqCandidateId = this.candidateDetails?.candidateId;
//     try {
//         this.loadAPIcall=true;
//         const res = await this.api.create("jobs/findAppliedJobs", this.obj).toPromise();
//         if (reqCandidateId !== this.candidateDetails?.candidateId) return;
//         this.handleResponse(res);
//         localStorage.setItem('jobsAppliedStatus',JSON.stringify(this.obj.status.split(',')));
//     } catch (err) {
//       if (reqCandidateId !== this.candidateDetails?.candidateId) return;
//       this.loadAPIcall=false
//         // this.util.stopLoader();
//     }
// }
private appliedJobsRequestId = 0;   // add near suggestedJobsRequestId

async getAppliedJobsList(status) {
  const requestId = ++this.appliedJobsRequestId;
  this.prepareRequest(status);
  const reqCandidateId = this.candidateDetails?.candidateId;
  try {
    this.loadAPIcall = true;
    const res = await this.api.create("jobs/findAppliedJobs", this.obj).toPromise();
    if (requestId !== this.appliedJobsRequestId || reqCandidateId !== this.candidateDetails?.candidateId) return;
    this.handleResponse(res);
    localStorage.setItem('jobsAppliedStatus', JSON.stringify(this.obj.status.split(',')));
  } catch (err) {
    if (requestId !== this.appliedJobsRequestId || reqCandidateId !== this.candidateDetails?.candidateId) return;
    this.loadAPIcall = false;
    this.afterPageSettled();
  }
}


  prepareRequest(status) {
    this.responseReceived = false;
    this.countss++;
    this.jobsAppliedFoundStatus = 'Fetching applied jobs...';
    this.obj = {
      candidateId: this.candidateDetails?.candidateId,
      searchAfterKey: this.previousSearchAfterKey ? this.previousSearchAfterKey : null,
      currentStatus: status,
      searchText : this.searchText
    };
    // this.util.startLoader();
  }

  handleResponse(res) {
    // this.util.stopLoader();
    this.loadAPIcall=false
    this.afterPageSettled();
    if (!res) return;
    this.responseReceived = true;
    if (res.code == "00000" && res.data) {
      this.processData(res.data);
     } else if (res.code == "99999") {
      this.jobsAppliedFoundStatus = 'Something went wrong, please try after some time.';
    }
  }

  processData(data) {

    if(data && data.jobList.length<9){
      this.stopscrollFlag=true
    }else{
      this.stopscrollFlag=false
      this.previousSearchAfterKey = data.searchAfterKey;
    }

    if (data.searchAfterKey) {
      data.jobList.forEach((ele,index) => this.processJobElement(ele,index));
    }
    if (data.jobList.length == 0) {
      this.noJobsFound();
    }
  }


  processJobElement(ele, i) {
    // ele.user.photo = ele.user.photo ? AppSettings.photoUrl + ele.user.photo : null;
    const existingIndex = this.passValues.findIndex(item => item.jobId === ele.jobId);

    // i hide the vertical timeline app-job-activity widget
    // so i commented the initial selected
    if (existingIndex !== -1) {
      this.passValues[existingIndex] = ele;
    } else {
      this.passValues.push(ele);
      if (i === 0 && this.obj.searchAfterKey == null && this.jobId == undefined) {
        ele.isSelected = false; // true
        this.pushtoparentcomponent(ele);
      } else if (this.jobId != undefined && this.jobId == ele.jobId) {
        this.passValues = this.passValues.map(item => ({
          ...item,
          isSelected: false
        }));
        ele.isSelected = false; // true
        this.pushtoparentcomponent(ele);
      }
    }
  }


  uniqueCandidates(passValues) {
    return passValues.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj.candidateId).indexOf(obj.candidateId) == pos;
    });
  }




  noJobsFound() {
    // this.stopscrollFlag = true;
    this.jobsAppliedFoundStatus = "There are no jobs applied for " + this.fullName + ".";
    this.messageShown = true;
    this.searchData.setNUllCheck("null");
    this.returnmsgtoActivity();
  }


   // message retunto activity
   returnmsgtoActivity(){
    let item :any={};
    // item.parentType="JOB_APPLICATION";
    item.parentType="JOB_APPLICATION,CANDIDATE_INVITATION";
    item.tab="cInvited";
    item.data = [];
    item.responseMessage=this.jobsAppliedFoundStatus;
    this.parentValueChange.emit(item)
  }



  searchConfig: any = {
    pageNumber: 0,
  }
  countss = -1;

  count: number = 0;
  getjobId(item) {
    this.getUpdate(item);
  }

  getUpdate(data) {
    if (!Array.isArray(this.passValues)) {
      return;
    }
    //update activitydate based on the timezone without refreshing the page by monisha
    this.passValues = this.passValues.map(element => {
      if (element.jobId === data.jobId) {
        // i removed the checkbox so i turned of the isselected as false
        return { ...element, isSelected: false, activityDate: data.activityDate }; // ✅ Update only the matched candidate
      }
      return { ...element, isSelected: false };
    });
  }
  @Output() parentValueChange = new EventEmitter<any>();
  pushtoparentcomponent(item) {
    item.parentType="JOB_APPLICATION,CANDIDATE_INVITATION";
    this.parentValueChange.emit(item)
    this.getUpdate(item)
   }




  scrollSubject = new Subject<void>();
  onScrollDown() {
    // scrollGate.armed: a page fetch needs one physical input (wheel / touch
    // / key) after the previous page landed; the smooth-scroll tail of a fast
    // flick has none and is dropped here.
    if (!this.loadAPIcall && !this.stopscrollFlag && this.scrollGate.armed) {
      this.scrollSubject.next();
    }
  }

  private loadNextPage() {
    if (this.loadAPIcall || this.stopscrollFlag) return;
    if (this.pageFrom == 'suggestedJobs') {
      // Only fetch the next page of an already-loaded list; a null
      // searchAfterKey would be a fresh (expensive) AI suggestion call.
      if (this.payload.searchAfterKey) {
        this.getSuggestedJobsList();
      }
    } else {
      const status = this.jobAppliedStatusList.map(oject => oject.itemId);
      this.getAppliedJobsList(status.toString());
    }
  }

  removedData : any ={}

  updatedArr() {
    const group = {};
    let arr = [...this.jobAppliedStatusList.map(c=>c.itemId)];
    arr.forEach((element)=>{
      group[element] = true;
    });
    return group;
  }

  removeEntity(value, index) {
    this.stopscrollFlag = false
    this.passValues = [] ;
    this.jobAppliedStatusList.splice(index, 1);
    this.removedData[value] = false;
    const status = this.jobAppliedStatusList.map(x=>x.itemId);
    this.previousSearchAfterKey=null;
    this.obj.searchAfterKey = null;
    this.filterByStatus(status.toString());

  }

  widgetstick: boolean = false
  @HostListener("window:scroll")
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= 5) {
      this.widgetstick = true;
    } else {
      this.widgetstick = false;
    }
  }

  selectStage(stage: string) {
    this.selectedStage = stage;
    this.passValues = []
    this.obj.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    // Reset scroll position to top when stage is changed
    this.resetScrollPosition();
    // When 'ALL' is selected, load ALL available statuses (not just defaults)
    if (stage === 'ALL') {
      // Load ALL statuses from tempStatusList (entire status list)
      if (this.tempStatusList) {
        this.jobAppliedStatusList = [...this.tempStatusList];

        // Update removedData to reflect all statuses
        this.removedData = {};
        this.jobAppliedStatusList.forEach(element => {
          this.removedData[element.itemId] = true;
        });
      }

      const allStages = this.jobAppliedStatusList.map(x => x.itemId);
      localStorage.setItem('jobsAppliedStatus', JSON.stringify(allStages));
      this.filterByStatus(allStages.toString());
      this.getJobsAppliedCounts();
    } else {
      // Handle single or multiple stage selection
      const stagesArray = stage.split(',');

      // Update jobAppliedStatusList to include selected stages
      if (this.tempStatusList) {
        this.jobAppliedStatusList = this.tempStatusList.filter((e) =>
          stagesArray.some(v => v === e.itemId)
        );

        // Update removedData to reflect selected stages
        this.removedData = {};
        this.jobAppliedStatusList.forEach(element => {
          this.removedData[element.itemId] = true;
        });
      }

      localStorage.setItem('jobsAppliedStatus', JSON.stringify(stagesArray));
      this.filterByStatus(stage);
      this.getJobsAppliedCounts();
    }
  }

  filterJobs(){
    // Emit search text to debounced subject
    this.searchSubject.next(this.searchText);
  }

  private executeSearch(){
    if(this.searchText == '' || this.searchText.trim() != ''){
      // const sts = JSON.parse(localStorage.getItem('jobsAppliedStatus') || '[]');
      this.passValues = []
      this.obj.searchAfterKey = null;
      this.previousSearchAfterKey = null;
      this.payload.searchAfterKey = null;
      this.stopscrollFlag = false;
      // Reset scroll position to top when search is performed
      this.resetScrollPosition();
      if(this.pageFrom == 'suggestedJobs'){
        this.getSuggestedJobsList();
      }else {
        this.filterByStatus(this.obj.currentStatus);
      }
    }
  }

  payload = {
    candidateId : '',
    limit : 10,
    groupType : 'SUGGESTED_JOB',
    searchContent : this.searchText,
    searchAfterKey: null
  }

  getSuggestedJobsList(){
    const requestId = ++this.suggestedJobsRequestId;
    const reqCandidateId = this.candidateDetails?.candidateId;
    this.payload.candidateId = reqCandidateId;
    this.payload.searchContent = this.searchText;
    // A null searchAfterKey means this is a fresh load (not a scroll page).
    // Reset the accumulating recruiter count so pagination doesn't stack onto
    // a previous candidate's / search's total.
    const wasFreshLoad = !this.payload.searchAfterKey;
    if (wasFreshLoad) {
      this.topMatchScore = 0;
      this.viaRecruitersCount = 0;
    }
    
    // Prevent API call for Draft status candidates
    const candidateStatus = this.candidateDetails?.status?.toUpperCase();
    console.log('[jobs-applied getSuggestedJobsList] candidateStatus:', candidateStatus, 'candidateId:', reqCandidateId);
    
    if (candidateStatus === 'DRAFT' || candidateStatus === 'DRAFTED') {
      console.log('[jobs-applied getSuggestedJobsList] Blocking API call for Draft candidate');
      this.loadAPIcall = false;
      this.afterPageSettled();
      this.responseReceived = true;
      this.passValues = [];
      this.stopscrollFlag = true;
      this.marketplaceTotalCount = 0;
      return;
    }
    
    console.log('[jobs-applied getSuggestedJobsList] Proceeding with API call');
    this.loadAPIcall = true;
    this.responseReceived = false;

    // Use retry mechanism: 3 retries with 25s delay = ~75s total
    this.api.suggestionsWithRetry('jobs/findTopSuggestedJobs', this.payload).subscribe({
      next: (res) => {
         if (requestId !== this.suggestedJobsRequestId || reqCandidateId !== this.candidateDetails?.candidateId) return;
        // if (reqCandidateId !== this.candidateDetails?.candidateId) return;
        this.loadAPIcall = false;
        this.afterPageSettled();
        this.responseReceived = true;
        if (res.code === GigsumoConstants.SUCESSCODE && res.data) {
          const newJobs = res.data.jobList || [];
          // Only update marketplaceTotalCount on fresh load, not on pagination
          // to prevent it from being overwritten with 0 on subsequent API calls
          if (wasFreshLoad) {
            this.marketplaceTotalCount = res.data.totalCount ?? 0;
               // Top Match = overall highest score (set each response). Via Recruiters
          // = per-page recruiter count, accumulated across pagination.
            this.topMatchScore = res.data.maxScore ?? 0;
            this.viaRecruitersCount = res.data.freelanceRecruiterCount ?? 0;
          }
          this.payload.searchAfterKey = res.data.searchAfterKey || null;

          // Process new jobs - add photo URLs
          // newJobs?.forEach((p: any) => {
          //   if (p?.user?.photo) {
          //     p.user.photo = AppSettings.photoUrl + p.user.photo;
          //   }
          // });

          // Append new jobs to existing list and remove duplicates
          const combinedJobs = [...this.passValues, ...newJobs];
          const uniqueJobsMap = new Map(combinedJobs.map(job => [job.jobId, job]));
          this.passValues = Array.from(uniqueJobsMap.values());

          // Check if we should stop scrolling
          if (newJobs.length < 10 || !this.payload.searchAfterKey) {
            this.stopscrollFlag = true;
          } else {
            this.stopscrollFlag = false;
          }
        }
      },
      error: (err) => {
        // if (reqCandidateId !== this.candidateDetails?.candidateId) return;
          if (requestId !== this.suggestedJobsRequestId || reqCandidateId !== this.candidateDetails?.candidateId) return;
      
        console.error('[suggested jobs] API Error:', err);
        this.loadAPIcall = false;
        this.afterPageSettled();
        this.responseReceived = true;
        this.stopscrollFlag = true;

        // Handle processing timeout (after max retries exhausted)
        if (err.timeout && err.isProcessing) {
          this.jobsAppliedFoundStatus = err.message || 'The AI is analyzing jobs. This may take a moment. Please try again shortly.';
        } else {
          // Other errors - silent handling, just log
          console.error('Failed to fetch suggested jobs:', err);
        }
      }
    });
  }

  handleStatusUpdate(){
    // AUDIT_04 CG6 — status change must refresh BOTH the stage-count cards
    // AND the list. Previously only the counts were refreshed, so a row
    // moved from Applied → Shortlisted stayed visible under the Applied
    // filter until a full candidate switch. Reset pagination and re-query
    // the current stage (mirrors `executeSearch()` reset pattern).
    this.getJobsAppliedCounts();
    this.passValues = [];
    this.obj.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.payload.searchAfterKey = null;
    this.stopscrollFlag = false;
    if (this.pageFrom == 'suggestedJobs') {
      this.getSuggestedJobsList();
    } else {
      this.filterByStatus(this.obj.currentStatus);
    }
  }

  getJobsAppliedCounts() {
    this.util.startLoader();
    const userID = localStorage.getItem('userId');
    const reqCandidateId = this.candidateDetails?.candidateId;
    let payload ={
      candidateId : reqCandidateId,
      userId : userID,
      owner : this.candidateDetails.createdBy == userID
    }
    this.api.create('candidates/getJobsAppliedCounts',payload).subscribe(res => {
      this.util.stopLoader()
      if (reqCandidateId !== this.candidateDetails?.candidateId) return;
      if (res.code == '00000') {
        const counts = res.data?.applicantsCount;
        if (counts) {
          this.stageCounts.applied = counts.applied ?? 0;
          this.stageCounts.inProcess = counts.inProcess ?? 0;
          this.stageCounts.selected = counts.selected ?? 0;
          this.stageCounts.offered = counts.offered ?? 0;
          this.stageCounts.onboarded = counts.onboarded ?? 0;
          this.stageCounts.all = counts.all ?? 0;
        }
      }
    }, err => {
      this.util.stopLoader();
    });
  }

}
